import React, { useId, useState } from "react"
import { ChevronDown } from "styled-icons/feather"

import * as styles from "../styles"

type CollapsibleSectionProps = {
  title: string
  description: string
  testId: string
}

const CollapsibleSection: React.FC<React.PropsWithChildren<CollapsibleSectionProps>> = ({ title, description, testId, children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [hasOpened, setHasOpened] = useState(false)
  const bodyId = useId()

  const toggle = () => {
    setIsOpen((wasOpen) => !wasOpen)
    setHasOpened(true)
  }

  return (
    <section>
      <styles.CollapsibleHeading>
        <styles.CollapsibleHeader
          type="button"
          aria-expanded={isOpen}
          aria-controls={bodyId}
          onClick={toggle}
          data-testid={testId}
        >
          <styles.CollapsibleTitles>
            <styles.CollapsibleTitle>{title}</styles.CollapsibleTitle>
            <styles.CollapsibleDescription>{description}</styles.CollapsibleDescription>
          </styles.CollapsibleTitles>
          <styles.ExpandIcon isExpanded={isOpen}>
            <ChevronDown size={18} />
          </styles.ExpandIcon>
        </styles.CollapsibleHeader>
      </styles.CollapsibleHeading>

      <styles.CollapsibleBody id={bodyId} $isOpen={isOpen} data-testid={`${testId}-body`}>
        <styles.CollapsibleClip>
          {/* Mounted on first open so a closed section loads nothing, then kept: rows hold unsaved edits and uploads. */}
          <styles.CollapsibleContent>{hasOpened && children}</styles.CollapsibleContent>
        </styles.CollapsibleClip>
      </styles.CollapsibleBody>
    </section>
  )
}

export default CollapsibleSection
